import type { Types } from '../types';
import type { OutTypes } from './schedules';
import { getVertexId } from '../util';
import { omitEdgesAndInternalProperties, type SerializedEdgesOnlyVertexExport, type SerializedEdgesShape } from './util';
import type { BaseOptions } from '../../common/types';
import type { ExceptionVertex } from '../interfaces/vertices/exceptions';
import { omit } from 'lodash-es';


export default (
  exceptions: Types.Mixed.Exception[],
  options:    BaseOptions
): OutTypes.exception[] => {
  return exceptions
    .map(x => {
      const edges: SerializedEdgesOnlyVertexExport<ExceptionVertex> = {
        exception: x.exception
          ? {
            ...omit(x.exception, 'to'),
            ...x.exception.to && { to: getVertexId(x.exception.to, options) }
          }
          : undefined,
        sources:          x.sources         ?.map(x => ({ toModel: x.toModel, to: getVertexId(x.to, options) })),
        exceptions:       x.exceptions      ?.map(x => getVertexId(x, options)),
        parentExceptions: x.parentExceptions?.map(x => getVertexId(x, options)),
      } satisfies SerializedEdgesShape<SerializedEdgesOnlyVertexExport<ExceptionVertex>>;
      const nonEdges = omitEdgesAndInternalProperties(x, edges);

      return { ...nonEdges, ...edges };
    });
};
